import React from "react";
import { Link, useHistory } from "react-router-dom";
import PageToolbar from "./PageToolbar.js";
import Button from "./Button/Button.js";

/**
 * Shown instead of a page the user isn't allowed to open: says why, names the
 * permission to ask an admin for, and offers a way out.
 */
export default function NoAccess({ permission }) {
    const history = useHistory();
    const perms = [].concat(permission || []).filter(Boolean);
    return (
        <div className="container py-3" style={{ maxWidth: 640 }}>
            <PageToolbar title="You don't have access to this page" />
            <p style={{ color: "var(--ink-body)" }}>
                Your account isn't allowed to open this page.
                {perms.length > 0 && (
                    <> Ask an admin to grant{" "}
                        {perms.map((p, i) => (
                            <React.Fragment key={p}>
                                {i > 0 && (i === perms.length - 1 ? " or " : ", ")}
                                <code>{p}</code>
                            </React.Fragment>
                        ))}
                        .
                    </>
                )}
            </p>
            <div className="d-flex flex-wrap gap-2">
                <Button variant="outline" onClick={() => history.goBack()}>
                    <i className="bi bi-arrow-left" aria-hidden="true" /> Go back
                </Button>
                <Link to="/" className="btn btn-outline-secondary">Go to Dashboard</Link>
            </div>
        </div>
    );
}
